import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { CollageCloudService, UiConfigurationService } from '@mirage-projects/cw-commons';

/**
 * Card service logic
 */
@Injectable({ providedIn: 'root' })
export class CardService {
    constructor(
        private collageCloudService: CollageCloudService,
        private uiConfigurationService: UiConfigurationService
    ) {}

    /**
     * Returns the default thumbnail image url
     * @param thumbnailUrl The thumbnail url
     */
    getDefaultThumbnail(): string {
        return `${this.uiConfigurationService.uiConfiguration.imgFolder}not-available.png`;
    }

    /**
     * Returns the signed image url so it can be shown in the card
     * @param thumbnailUrl The thumbnail url
     */
    getThumbnailUrl(thumbnailUrl: string): Observable<string> {
        return thumbnailUrl ? this.collageCloudService.getRedirectURL(thumbnailUrl) : of(this.getDefaultThumbnail());
    }
}
